import { FormEvent, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import AuthLayout from '../../components/layout/AuthLayout';
import { resetPasswordByEmail } from '../../lib/auth';

export default function ForgotPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      await resetPasswordByEmail(email, password);
      navigate('/sites', { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : '重置失败');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AuthLayout title="找回密码" subtitle="输入注册邮箱并设置新密码。知道邮箱即可重置，不会发送验证邮件。">
      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="注册邮箱"
          className="px-4 py-3 rounded-md border border-background-200 text-sm"
        />
        <input
          type="password"
          required
          minLength={6}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="新密码，至少 6 位"
          className="px-4 py-3 rounded-md border border-background-200 text-sm"
        />
        {error && <p className="text-sm text-primary-700">{error}</p>}
        <button
          type="submit"
          disabled={submitting}
          className="py-3 text-sm font-semibold text-background-50 bg-primary-500 rounded-md disabled:opacity-60"
        >
          {submitting ? '提交中…' : '重置并登录'}
        </button>
      </form>
      <p className="mt-6 text-sm text-foreground-600">
        想起密码了？{' '}
        <Link to="/login" className="font-semibold text-primary-600">
          返回登录
        </Link>
      </p>
    </AuthLayout>
  );
}
